// src/modulos/Dashboard/DashboardPage.js
import React from 'react';
import useAuth from '../../hooks/useAuth';
import useFirestore from '../../hooks/useFirestore';

// Import role-specific dashboard components
import AdminDashboard from '../Dashboard/AdminDashboard';
import ComercialDashboard from '../Dashboard/ComercialDashboard';
import DiretoriaDashboard from '../Dashboard/DiretoriaDashboard';
import LaboratorioDashboard from '../Dashboard/LaboratorioDashboard';
import LogisticaDashboard from '../Dashboard/LogisticaDashboard';
import MarketingDashboard from '../Dashboard/MarketingDashboard';
import TIDashboard from '../Dashboard/TIDashboard';
import DefaultDashboard from '../Dashboard/DefaultDashboard';

const DashboardPage = () => {
    const { currentUser } = useAuth();

    // ✅ Fix: Fetch all users and filter (not ideal for large datasets)
    const { data: usersData, loading: usersLoading } = useFirestore('users');

    // ✅ Find current user from all users
    const userProfile = usersData?.find(user => user.email === currentUser?.email) || null;
    const userRole = userProfile?.role || 'Default';

    // Combined loading state
    const loading = usersLoading;

    // Loading state
    if (loading) {
        return (
            <div style={{
                padding: '20px',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'calc(100vh - 200px)'
            }}>
                <div>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '3px solid #f3f4f6',
                        borderTop: '3px solid #6366f1',
                        borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite',
                        margin: '0 auto 16px'
                    }} />
                    <p style={{ color: '#6b7280', fontSize: '14px' }}>Carregando dashboard...</p>
                </div>
            </div>
        );
    }

    // Role-based dashboard renderer
    const renderDashboardByRole = () => {
        switch (userRole) {
            case 'Administracao':
                return <AdminDashboard user={userProfile} />;
            case 'Comercial':
                return <ComercialDashboard user={userProfile} />;
            case 'Diretoria':
                return <DiretoriaDashboard user={userProfile} />;
            case 'Laboratorio':
                return <LaboratorioDashboard user={userProfile} />;
            case 'Logistica':
                return <LogisticaDashboard user={userProfile} />;
            case 'Marketing':
                return <MarketingDashboard user={userProfile} />;
            case 'TI':
                return <TIDashboard user={userProfile} />;
            default:
                return <DefaultDashboard user={userProfile} />;
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            {renderDashboardByRole()}
        </div>
    );
};

export default DashboardPage;